import React from 'react';
import '../Styles/PayButton.css';

const PayButton = props => {
    return(
    <div className="payButtonCard">
        <button type="button"  className="payButton" onClick={ 
            () =>{
                if(props.myaction !== undefined){
                    props.myaction()
                    console.log("Enviado!")
                }
                else if (props.go == true){
                    window.location.href=props.link;
                }
            }
        }>
            <img src={props.img} alt="tick"/>
        </button>
        <p>{props.text}</p>    
    </div>
    )
}

export default PayButton;
